import React from 'react'

const CareerOpportunities = () => (
  <div className='career-opportunities-container p-5'>
    <div className='career-opportunities white'>
      <h3 className=''>Our career opportunities</h3> 
      <p className='mt-3 career-opportunities-text'>
        At Yard, our future is rooted in helping our people unleash their potential in creating Australia’s best home loan offering.
      </p>
      <p className='mt-3 career-opportunities-text'>
        We’ve got an ambitious road ahead. Join our team and help us shape the future.
      </p>
    </div>
    <div className='card-body bottom text-center career-button-container'>
      <a className='btn btn-xl btn-white view-our-career-button' style={{ color: '#066447' }} href="/resources/careers">
        <span className='black'>See vacancies</span>
      </a>
    </div>
  </div>
);

export default CareerOpportunities
